import React from 'react';
import Avatar from '../common/avatar';
import {ASSISTANT_CLASSES} from '../../models/message.model';

const InfoMessage = ({text, html}: {text?: string; html?: string}) => {
	return (
		<div className={`flex my-3 items-end`}>
			<Avatar/>
			<div className={`p-4 pt-3.5 rounded-sm flex ${ASSISTANT_CLASSES}`}>
				{text ? <span className="mt-0.5 whitespace-pre-line" style={{wordBreak: 'break-word'}}>{text}</span> :
					<span dangerouslySetInnerHTML={{__html: html || ''}}></span>
				}
			</div>
		</div>
	);
};

export default InfoMessage;
